// 品牌：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 品牌界面
export const ui = Object.freeze({
  "pcBrand.back": "Back",
  "pcBrand.unknown": "Unknown",
  "pcBrand.uncategorized": "Uncategorized",
  "pcBrand.claimBrand": "Claim brand",
  "pcBrand.brandManagement": "Brand management",
  "pcBrand.brandIntroduction": "Brand introduction",
  "pcBrand.noBrandIntroduction": "No brand introduction",
  "pcBrand.companyIntroduction": "Company introduction",
  "pcBrand.noCompanyIntroduction": "No company introduction",
  "pcBrand.openProductData": "Open product data",
  "pcBrand.productImage": "Product image",
  "pcBrand.sold": "Sold:",
  "pcBrand.noProductData": "No product data",
  "pcBrand.relatedCompanies": "Related companies",
  "pcBrand.brandOwner": "Brand owner",
  "pcBrand.distributor": "Distributor",
  "pcBrand.trader": "Trader",
  "pcBrand.active": "Active",
  "pcBrand.disabled": "Disabled",
  "pcBrand.unknownType": "Unknown type",
  "pcBrand.visitCompany": "Visit company",
  "pcBrand.noRelatedCompanies": "No related companies",
  "pcBrand.noRelatedCompaniesOfThisType": "No related companies of this type",
  "pcBrand.relatedProductFamilies": "Related product families",
  "pcBrand.value1Model": "1 model",
  "pcBrand.relatedOrders": "Related orders",
  "pcBrand.orders": "Orders",
  "pcBrand.tradedQuantity": "Traded quantity",
  "pcBrand.tradeValue": "Trade value",
  "pcBrand.tradingRegions": "Trading regions",
  "pcBrand.time": "Time",
  "pcBrand.tradedModel": "Traded model",
  "pcBrand.product": "Product",
  "pcBrand.region": "Region",
  "pcBrand.quantity": "Quantity",
  "pcBrand.transactionValue": "Trade value",
  "pcBrand.createdAt": "Created at",
  "pcBrand.brandStrengths": "Brand strengths",
  "pcBrand.leadingTechnology": "Leading technology",
  "pcBrand.industryLeadingRDCapabilitiesAndPatents":
    "Industry-leading R&D capabilities and patents",
  "pcBrand.qualityAssurance": "Quality assurance",
  "pcBrand.rigorousQualityControlsToEnsureProductQuality":
    "Rigorous quality controls to ensure product quality",
  "pcBrand.marketLeadership": "Market leadership",
  "pcBrand.aStrongMarketShareInTheIndustry": "A strong market share in the industry",
  "pcBrand.comprehensiveService": "Comprehensive service",
  "pcBrand.comprehensiveTechnicalSupportAndAfterSalesService":
    "Comprehensive technical support and after-sales service",
  "pcBrand.companyNews": "Company news",
  "pcBrand.partners": "Partners",
  "pcBrand.relatedBrands": "Related brands",
  "pcBrand.more": "More ▼",
  "pcBrand.collapse": "Collapse ▲",
  "pcBrand.beijing0Shanghai0Guangzhou0Shenzhen0":
    "Beijing 0 | Shanghai 0 | Guangzhou 0 | Shenzhen 0",
  "pcBrand.applications": "Applications",
  "pcBrand.trademarkRegistrationCertificates": "Trademark registration certificates",
  "pcBrand.companyName": "Company name",
  "pcBrand.enterCompanyName": "Enter company name",
  "pcBrand.companyType": "Company type",
  "pcBrand.trademarkCertificate": "Trademark certificate",
  "pcBrand.distributorAuthorizationCertificate": "Distributor authorization certificate",
  "pcBrand.uploadTrademarkCertificate": "Upload trademark certificate",
  "pcBrand.uploadAuthorizationCertificate": "Upload authorization certificate",
  "pcBrand.cancel": "Cancel",
  "pcBrand.confirm": "Confirm",
  "pcBrand.companyNameIsRequired": "Company name is required",
  "pcBrand.selectCompanyType": "Select company type",
  "pcBrand.trademarkNumber": "Trademark number",
  "pcBrand.headquarters": "Headquarters",
  "pcBrand.productLines": "Product lines",
  "pcBrand.authorizedRegions": "Authorized regions",
  "pcBrand.authorizationPeriod": "Authorization period",
  "pcBrand.mainModels": "Main models",
  "pcBrand.monthlySupplyCapacity": "Monthly supply capacity",
  "pcBrand.china": "China",
  "pcBrand.shenzhen": "Shenzhen",
  "pcBrand.eastChina": "East China",
  "pcBrand.southChina": "South China",
  "pcBrand.shanghaiJiangsuZhejiangAnhui": "Shanghai, Jiangsu, Zhejiang, Anhui",
  "pcBrand.microcontrollersPowerManagementSensorsConnectivityChips":
    "Microcontrollers, power management, sensors, connectivity chips",
  "pcBrand.value20260101To20261231": "2026-01-01 to 2026-12-31",
  "pcBrand.brandClaimedSuccessfully": "Brand claimed successfully",
  "pcBrand.brandIdIsRequired": "Brand ID is required",
  "pcBrand.couldNotLoadBrandDetails": "Could not load brand details",
  "pcBrand.brandInformation": "Brand information",
  "pcBrand.brandName": "Brand name",
  "pcBrand.enterTheChineseBrandName": "Enter the Chinese brand name",
  "pcBrand.selectBrand": "Select brand",
  "pcBrand.englishName": "English name",
  "pcBrand.enterTheEnglishBrandName": "Enter the English brand name",
  "pcBrand.brandRegion": "Brand region",
  "pcBrand.selectBrandRegion": "Select brand region",
  "pcBrand.brandCategory": "Brand category",
  "pcBrand.selectBrandCategory": "Select brand category",
  "pcBrand.yearFounded": "Year founded",
  "pcBrand.enterBrandIntroduction": "Enter brand introduction",
  "pcBrand.enterCompanyIntroduction": "Enter company introduction",
  "pcBrand.smartSecurity": "Smart security",
  "pcBrand.homeAppliances": "Home appliances",
  "pcBrand.smartIot": "Smart IoT",
  "pcBrand.medicalElectronics": "Medical electronics",
  "pcBrand.communicationsNetworks": "Communications networks",
  "pcBrand.energyControl": "Energy control",
  "pcBrand.consumerElectronics": "Consumer electronics",
  "pcBrand.industrialControl": "Industrial control",
  "pcBrand.automotiveElectronics": "Automotive electronics",
  "pcBrand.brandLogo": "Brand logo",
  "pcBrand.uploadLogo": "Upload logo",
  "pcBrand.contactInformation": "Contact information",
  "pcBrand.privacyProtection": "Privacy protection",
  "pcBrand.contact": "Contact",
  "pcBrand.enterContactName": "Enter contact name",
  "pcBrand.contactPhone": "Contact phone",
  "pcBrand.enterContactPhone": "Enter contact phone",
  "pcBrand.email": "Email",
  "pcBrand.enterEmailAddress": "Enter email address",
  "pcBrand.reset": "Reset",
  "pcBrand.submitApplication": "Submit application",
  "pcBrand.brandNameIsRequired": "Brand name is required",
  "pcBrand.brandRegionIsRequired": "Brand region is required",
  "pcBrand.brandCategoryIsRequired": "Brand category is required",
  "pcBrand.yearFoundedIsRequired": "Year founded is required",
  "pcBrand.submittedSuccessfully": "Submitted successfully",
  "pcBrand.foundedInYear": "Founded in {year}",
  "pcBrand.productsCount": "Products ({count})",
  "pcBrand.expandCountMore": "Expand ({count} more) ▼",
  "pcBrand.moreCount": "More ({count}) ▼",
  "pcBrand.countFamilies": "{count} families",
  "pcBrand.countTrades": "{count} trades",
  "pcBrand.shownTotalCompanies": "{shown} / {total} companies",
  "pcBrand.uploadType": "Upload {type}",
  "pcBrand.brandLaunchesNewProducts": "{brand} launches new products",
  "pcBrand.brandLaunchedNewProductsTodayBringingInnovativeSolutionsToTheMarket":
    "{brand} launched new products today, bringing innovative solutions to the market.",
  "pcBrand.brandAnnouncesStrategicPartnerships":
    "{brand} announces strategic partnerships",
  "pcBrand.brandHasFormedStrategicPartnershipsWithCompaniesToAdvanceTheIndustry":
    "{brand} has formed strategic partnerships with companies to advance the industry.",
  "pcBrand.brandReportsGrowthIn2025": "{brand} reports growth in 2025",
  "pcBrand.brandGrewIn2025AndExpandedItsMarketShare":
    "{brand} grew in 2025 and expanded its market share.",
  "pcBrand.chinaMasterDistributor": "China master distributor",
  "pcBrand.eastChinaDistributor": "East China distributor",
  "pcBrand.southChinaDistributor": "South China distributor",
  "pcBrand.nationwideTrader": "Nationwide trader",
  "pcBrand.regionalTrader": "Regional trader",
  "pcBrand.authorizedTrader": "Authorized trader",
});

// 页面受控选项与属性显示；原始业务值保持不变。
export const metadataFollowup = Object.freeze({
  "pcBrand.categoryVaristorGdt": "Varistor & Gas Discharge Tube",
  "pcBrand.categoryDiodes": "Diodes",
  "pcBrand.categoryTransistors": "Transistors",
  "pcBrand.categoryResistors": "Resistors",
  "pcBrand.categoryCapacitors": "Capacitors",
  "pcBrand.categoryInductors": "Inductors",
  "pcBrand.regionUnitedKingdom": "United Kingdom",
  "pcBrand.regionGermany": "Germany",
  "pcBrand.regionFrance": "France",
  "pcBrand.regionSingapore": "Singapore",
  "pcBrand.regionHongKong": "Hong Kong, China",
});

export const messages = Object.freeze({
  ...metadataFollowup, ...ui });

// 已登记品牌显示别名
export const brandNames = Object.freeze({
  镁光: "Micron",
  美光: "Micron",
  三星: "Samsung",
  现代: "Hyundai",
  英特尔: "Intel",
  海力士: "SK hynix",
  金士顿: "Kingston",
  兆易创新: "GigaDevice",
  英伟达: "NVIDIA",
  长江存储: "YMTC",
  长鑫: "CXMT",
  广达: "Quanta",
  摩尔线程: "Moore Threads",
  时创意: "SCY",
  "闪迪/SANDISK": "SanDisk",
  南亚: "Nanya",
  紫光国芯: "Ziguang Guoxin",
  安世: "Nexperia",
  ST意法半导体: "STMicroelectronics",
  TI德州仪器: "Texas Instruments",
  "TOSHIBA/东芝": "Toshiba",
  "onsemi/安森美": "onsemi",
  "Yeestor/得一微": "Yeestor",
  "AMD/超微": "AMD",
  "OADATA/威刚": "ADATA",
  "江波龙/FORESEE": "FORESEE",
  "高通/GENITOP": "GENITOP",
  "富士通/FUJITSU": "Fujitsu",
  "芯邦/Chipsbank": "Chipsbank",
  "上海贝岭/BL": "Shanghai Belling",
  "深圳汉芯/HGC": "HGC",
  "宏旺/DICMAX": "DICMAX",
  "海天芯/CHTCSEMI": "CHTCSEMI",
  "英飞凌/Infineon": "Infineon",
  华虹挚芯: "Huahong Zhixin",
  "夏普/OSHARP": "Sharp",
  "澜智/Zetta": "Zetta",
  "华邦/Winbond": "Winbond",
  "伍尔特/OWurth": "Wurth",
  "恒烁/Zbit": "Zbit",
  "芯伯乐/XBLW": "XBLW",
  "芯天下/XTX": "XTX",
  "唯创知音/OWT": "OWT",
  "威世/CVISHAY": "Vishay",
  "精工/Seiko": "Seiko",
  "森萨塔/Sensata": "Sensata",
  "上海矽朋/Siproin": "Siproin",
  "三友/SANYOU": "SANYOU",
  "罗姆/OROHM": "ROHM",
  "晶存/Rayson": "Rayson",
  "瑞萨/RENESAS": "Renesas",
  "恩智浦/ONXP": "NXP",
  "迪浦/PUOLOP": "PUOLOP",
  "普冉/PUYA": "Puya",
  "米客方德/MK": "MK",
  "灵星芯微/OLX": "OLX",
  "来扬/Lyontek": "Lyontek",
  "力积电子/Zentel": "Zentel",
});

// 已登记分类显示别名
export const categoryNames = Object.freeze({
  IC存储器: "IC memory",
  DDR颗粒: "DDR chips",
  wafer晶圆: "Wafers",
  FLASH颗粒: "Flash chips",
  服务器: "Servers",
  国产服务器: "Domestic servers",
  进口服务器: "Imported servers",
  电位器: "Potentiometers",
  保险丝: "Fuses",
  服务器条子: "Server memory modules",
  内存条: "Memory modules",
  "Nand Flash BGA颗粒": "NAND Flash BGA chips",
});

// 已登记地区显示别名
export const regionNames = Object.freeze({
  韩国: "South Korea",
  美国: "United States",
  中国: "China",
  台湾: "Taiwan",
  欧洲: "Europe",
  日本: "Japan",
});
